export default __webpack_public_path__ + "static/media/errorImg.a9e87832.png";